module.exports = __webpack_public_path__ + "static/media/file.9aedab78.pdf";